import React from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import TableContainer from '@material-ui/core/TableContainer'
import TextField from '@material-ui/core/TextField'
import axios from 'axios'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import TextareaAutosize from '@material-ui/core/TextareaAutosize'

import SignaturePad from 'react-signature-pad'
import Button from '@material-ui/core/Button'
import DateFnsUtils from '@date-io/date-fns'
import {MuiPickersUtilsProvider,DatePicker} from '@material-ui/pickers'
import Loader1 from './Loader1'
import Header from './Header'
import {Redirect} from 'react-router-dom'


class Rmaform extends React.Component
{
constructor(props)
{
    super(props)
    this.state= {
        products1:[],
        productname:'',
        location1:[],
        location:'',
        salestaff:'',
        invoiceno:'',
        invoicedate:new Date(),
        customername:'',
        complaint:'',
        emailid:'',
        signature1:'',
        files:[],
        images1:'',
        image1:null,
        image2:null,
        image3:null,
        image4:null,
        image5:null,
        errors:{},
        success:'',
        loading:false,
        redirect:false,
        phone:'',
        complaintcomments:''

    }
    this.signature2 = React.createRef()

}
componentDidMount()
{
    
axios.get('https://www.thespiritofdubai.com/rmaform/data/data.php').then(res=> {
const products = res.data.g1
this.setState({products1:products}) 
const locations =res.data.loc
this.setState({location1:locations})
})
}
handleChange=(e)=>{

let name=e.target.name
let val=e.target.value

    this.setState({[name]:val})


}
handledateChange=(date)=>
{
    this.setState({invoicedate:date})
}
handleChange1=(e)=>
{
    this.setState({image1:e.target.files[0]})
}
handleChange2=(e)=>
{
    this.setState({image2:e.target.files[0]})
}
handleChange3=(e)=>
{
    this.setState({image3:e.target.files[0]})
}
handleChange4=(e)=>
{
    this.setState({image4:e.target.files[0]})
}
handleChange5=(e)=>
{
    this.setState({image5:e.target.files[0]})
}
handleEnd=(data)=>
{
 
 const signature = this.signature2
 this.setState({signature1:signature.current.toDataURL()})
}

handleSubmit=(e)=>{
   

if(this.validateForm())
{    

   /* const formdata=new FormData()
    formdata.append('image',this.state.image1)
    axios.post('http://localhost/customersurvey/upload.php',formdata,{}).catch(()=>{
        console.log('error')
    })
*/


const formdata=new FormData()
formdata.append('productname',this.state.productname)
formdata.append('location',this.state.location)
formdata.append('salestaff',this.state.salestaff)
formdata.append('invoiceno',this.state.invoiceno)
formdata.append('invoicedate',this.state.invoicedate)
formdata.append('customername',this.state.customername)
formdata.append('complaint',this.state.complaint)
formdata.append('emailid',this.state.emailid)
formdata.append('phone',this.state.phone)
formdata.append('image1',this.state.image1)
formdata.append('image2',this.state.image2)
formdata.append('image3',this.state.image3)
formdata.append('image4',this.state.image4)
formdata.append('image5',this.state.image5)
formdata.append('signature1',this.state.signature1)
formdata.append('complaintcomments',this.state.complaintcomments)
this.setState({loading:true})
    axios({
        method:"post",
        url:"https://www.thespiritofdubai.com/rmaform/php/insertdata.php",
        mode:"no-cors",
        withCredentials:false,
        data:formdata,
        headers: {"Content-type": "multipart/form-data"}
    }).then((res)=>{
       
        this.setState({loading:false})
       this.setState({redirect:true})
      
      
        

    })

}
}
validateForm()
{
let formIsValid=true
let errors={}
if(!this.state.productname)
{    
    formIsValid=false
    errors['pronamerro']='Please Select Product Name'
}
if(!this.state.location)
{    
    formIsValid=false
    errors['locationerro']='Please Select Location'
}

if(!this.state.invoiceno)
{    
    formIsValid=false
    errors['invoicenoerro']='Please Enter Invoiceno'
}
if(!this.state.invoicedate)
{    
    formIsValid=false
    errors['invoicedateerro']='Please Enter Invoice Date'
}
if(!this.state.salestaff)
{    
    formIsValid=false
    errors['salestafferro']='Please Enter Sales Staff'
}
if(!this.state.customername)
{    
    formIsValid=false
    errors['customernameerro']='Please Enter Customer Name'
}
if(!this.state.customername)
{    
    formIsValid=false
    errors['customernameerro']='Please Enter Customer Name'
}
if(!this.state.emailid)
{    
    formIsValid=false
    errors['emailiderro']='Please Enter Valid Email'
}
if(!this.state.phone)
{    
    formIsValid=false
    errors['phoneerro']='Please Enter Phone'
}
if(!this.state.complaint)
{    
    formIsValid=false
    errors['complainterro']='Please Enter Complaint'
}

if(!this.state.image1)
{ 
    formIsValid=false
    errors['imageserro']='Please Select Images'
}
if(!this.state.complaintcomments)
{
    formIsValid=false
    errors['complaintcommentserro']='Please Enter Comments'
}
if(!this.state.signature1)
{
 formIsValid=false
 errors['cussignerr']='Please customer signature'

}

this.setState({errors:errors})
return formIsValid
}
render()
{
 const err={
     color:"#f00"
 } 
 if(this.state.loading) return <Loader1 /> 
 if(this.state.redirect) return <Redirect to="/view" />
return(
    <>
   <Grid container direction="row" justify="center" alignItems="center">
       <Grid item xs={12}>
    <input type="hidden" name='signature1' value={this.state.signature1} />  
    <input type="hidden" name='images1' value={this.state.images1} />  
    <form method='post' encType='multipart/form-data'>     
   <TableContainer >
    <Table style={{width:"90%",margin:"auto"}}>
        <Header />
        <TableBody>
        <TableRow>
            <TableCell align="center" colSpan="2" style={{height:"20px"}}><h6><u>RETURN MERCHANDISE AUTHORIZATION</u></h6></TableCell>
        </TableRow>
        <TableRow><TableCell align="center" colSpan="2" style={{color:"green",fontSize:"20px"}}>{this.state.success}</TableCell></TableRow>
        <TableRow>
            <TableCell colSpan="2" style={{lineHeight:"10px"}}>
                <h5 style={{margin:"10px"}}>
                <u>SALES STAFF:</u>
                </h5></TableCell>
        </TableRow>
        <TableRow>
            <TableCell style={{paddingLeft:"20px"}}>
               Product: 
            </TableCell>
            <TableCell>
                <TextField name='productname'   id="outlined-select-currency" select label='Select Product'  onChange={this.handleChange} variant="outlined" value={this.state.productname}>
                {this.state.products1.map((res)=>
                <MenuItem key={res} value={res}>{res}</MenuItem>
                 
                 )}
                    
                </TextField>
                <div style={err}>{this.state.errors.pronamerro}</div>  
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>Location</TableCell>
            <TableCell >
                <TextField name='location'select   label='Select Location' variant='outlined' onChange={this.handleChange} value={this.state.location}>
                {this.state.location1.map((res)=>
                <MenuItem key={res} value={res}>{res}</MenuItem>
                )}
                </TextField>
                <div style={err}>{this.state.errors.locationerro}</div>  
                </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>Sales Staff</TableCell>
            <TableCell><TextField  name='salestaff'  variant='outlined' value={this.state.salestaff} onChange={this.handleChange}/>
            
            <div style={err}>{this.state.errors.salestafferro}</div>  
            </TableCell>
        </TableRow>
        <TableRow>
           <TableCell>
            Invoice No#
            </TableCell>
            <TableCell>
                <TextField name='invoiceno'  value={this.state.invoiceno} variant='outlined' onChange={this.handleChange}></TextField>
                <div style={err}>{this.state.errors.invoicenoerro}</div>  
            </TableCell>         
        </TableRow>   
        <TableRow>
           <TableCell>
            Invoice Date
            </TableCell>
            <TableCell>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker  autoOk   name='invoicedate' value={this.state.invoicedate} format='dd/MM/yyyy' inputVariant='outlined' variant="inline" onChange={this.handledateChange} />
                </MuiPickersUtilsProvider>
                <div style={err}>{this.state.errors.invoicedateerro}</div>  
                
            </TableCell>         
        </TableRow>   
        <TableRow>
             <TableCell colSpan="2"><h5><u>CUSTOMER:</u></h5></TableCell>       
        </TableRow>
        <TableRow>
         <TableCell>Name</TableCell>
         <TableCell>
             <TextField   variant='outlined' name='customername' value={this.state.customername} onChange={this.handleChange}></TextField>
             <div style={err}>{this.state.errors.customernameerro}</div>  
             </TableCell>

        </TableRow> 
        <TableRow>
         <TableCell>Email</TableCell>
         <TableCell>
             <TextField  variant='outlined' name='emailid' value={this.state.emailid} onChange={this.handleChange}></TextField>
             <div style={err}>{this.state.errors.emailiderro}</div>  
             </TableCell>

        </TableRow>
        <TableRow>
         <TableCell>Phone</TableCell>
         <TableCell>
             <TextField  variant='outlined' name='phone' value={this.state.phone} onChange={this.handleChange}></TextField>
             <div style={err}>{this.state.errors.phoneerro}</div>  
             </TableCell>

        </TableRow>
        <TableRow>
        <TableCell>
            Nature of Complaint
        </TableCell>
        <TableCell>
            <TextareaAutosize name='complaint'  value={this.state.complaint} rows={4}  style={{width:"100%"}} onChange={this.handleChange}/>

            <div style={err}>{this.state.errors.complainterro}</div>  
        </TableCell>
        </TableRow>         
        <TableRow>
        <TableCell>
            Photo
        </TableCell>
        <TableCell>
           

            <input type="file"   onChange={this.handleChange1} />
            <br /><br />
            <input type="file"  onChange={this.handleChange2} />
            <br /><br />
            <input type="file"  onChange={this.handleChange3} />
            <br /><br />

            <input type="file"  onChange={this.handleChange4} />
            <br /><br />
            <input type="file"  onChange={this.handleChange5} />
            <div style={err}>{this.state.errors.imageserro}</div> 
        </TableCell>
        </TableRow> 
        <TableRow>
            <TableCell>Comments by Sales Staff</TableCell>
            <TableCell>
            <TextareaAutosize name='complaintcomments'  value={this.state.complaintcomments} rows={4}  style={{width:"100%"}} onChange={this.handleChange}/>

             <div style={err}>{this.state.errors.complaintcommentserro}</div>        

            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>Signature</TableCell>
            <TableCell >
               <SignaturePad ref={this.signature2} clearButton={true} onEnd={this.handleEnd} />
               <div style={err}>{this.state.errors.cussignerr}</div> 
               
            </TableCell>
        </TableRow>               
        <TableRow>
            <TableCell align="center" colSpan={2}>
                    <Button color='secondary' variant='contained' onClick={this.handleSubmit}>Submit</Button>
            </TableCell>
        </TableRow>            
               
        </TableBody>
    </Table>
   </TableContainer>
   </form>
   </Grid> </Grid>
    </>
)

}


}
export default Rmaform;